import { render, staticRenderFns } from "./InfoPerusahaan.vue?vue&type=template&id=3ea58082&"
import script from "./InfoPerusahaan.vue?vue&type=script&lang=js&"
export * from "./InfoPerusahaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports